// Shared UMD scripts publish on window after Babel adds polyfill imports.
// Use that browser API rather than an undefined synthetic default export.
import '@groupResources/auth/tc-inbox'

export default window.TCInbox
